import React from 'react';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { DatePicker, Space, Card, Typography } from 'antd';
const { RangePicker } = DatePicker;

const VehicleUploads = ({ uploadsByDate, uploads, getUploads, getUploadsByDate }) => {
	useEffect(() => {
		getUploads();
	}, []);

	return (
		<div className="page">
			<div className="cards">
				<Card style={{ width: 200, backgroundColor: '#66c2ff' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Total Uploads</p>
						<p className="card-value">{uploads?.totalVehicles}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#ff80bf' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Uploads With 24 hr</p>
						<p className="card-value">{uploads?.uploadedToday}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#71da71' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Uploads Within a week</p>
						<p className="card-value">{uploads?.uploadedThisWeek}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#CCCC66' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Uploads Within a month</p>
						<p className="card-value">{uploads?.uploadedThisMonth}</p>
					</Typography.Text>
				</Card>
			</div>

			<div className="analytics-container">
				<Card style={{ width: 350, height: 144, backgroundColor: '#666666' }} hoverable>
					<Space direction="vertical" size={12}>
						<RangePicker
							showTime
							onOk={(value) => {
								getUploadsByDate(value);
							}}
						/>
					</Space>
					<Typography.Text>
						<p className="card-heading">Uploads Within Range</p>
						<p className="card-value">{uploadsByDate?.vehiclesByDate}</p>
					</Typography.Text>
				</Card>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	uploads: state.vehicleUploads.uploads,
	uploadsByDate: state.vehicleUploads.uploadsByDate,
});

const mapDispatchToProps = (dispatch) => ({
	getUploadsByDate: (value) => dispatch(Actions.getUploadsByDate(value)),
	getUploads: () => dispatch(Actions.getUploads()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VehicleUploads));
